import React, { Component } from 'react';
import { connect } from 'react-redux';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Toast from './sub_components/toast';
import * as currencyService from '../services/currencyService';
import * as authServices from '../services/authService';
import * as utilService from '../services/utilService';
import * as apiUserService from '../services/apiUserService'
import { BASE_IMAGE_PATH } from '../configs/api';
import { BASE_IMAGE_PATH_NEW } from '../configs/api';
import { BRANDLOGOFILENAME } from '../configs/authSignupConfig';
import UnderMaintenance from './under_maintenance';
import CaptchaComp from './sub_components/captchaComp';

let sendotpinterval;
class Auth extends Component {
   constructor(props) {
      super(props);
      this.state = {
         uid: "",
         passcode: "",
         toastMsg: "",
         toastType: "",
         passVisible: false,
         forgPassvisible: false,
         confPassvisible: false,
         signUpPassword: false,
         signUpConfPass: false,
         opLoader: false,
         isMaintenance: false,
         inMaitanenceMessage: '',
         loginForm: 0,
         signUpStep: 0,
         personName: "",
         usernamesignup: "",
         usernamealreadyexist: false,
         passwordsignup: "",
         passwordsignup_confirm: "",
         mobileNumber: "",
         mobilealreadyexist: false,
         mobilealreadyexistchecked: false,
         mobileNumberCountryCode: "",
         mobileNumberisValid: false,
         emailsignup: "",
         confirmPassVisible: false,
         signUpReferenceCode: '',
         currenyList: [],
         currency: '',
         signUpMinDate: '1923-08-08',
         signUpMaxDate: '2005-08-08',
         signUpDOB: '',
         otherDrop: '',
         otherTxt: '',
         referrer: '',
         website: '',
         otp: '',
         otpSent: 0,
         otpsignup: "",
         otpSentTo: '',
         resendOtp: 0,
         requestId: null,
         captchaSolution: '',
         expiryCaptcha: 0
      };
   }



   componentWillMount() {
      // utilService.checkMaintainanceCall().then((res) => {
      //    if (res.isSuccess && !!res.items && res.items.isMaintenance) {
      //       this.setState({
      //          isMaintenance: true,
      //          inMaitanenceMessage: res.items
      //       })
      //    }
      // })
   }

   componentDidMount() {

      this.getCurrencyLst();
      // let self = this;
      // const urlParams = new URLSearchParams(window.location.search);
      // const token = urlParams.get('token');

      // if (!!token) {

      //    this.setState({ opLoader: true });
      //    authServices.getUserToken(token).then(async (result) => {

      //       if (result.token) {
      //          let data = {
      //             token: result.token
      //          }
      //          localStorage.setItem("userAuthDetail", JSON.stringify(data))
      //          let velidateData = await authServices.velidateToken()
      //          if (!!velidateData.role && velidateData.role !== "Client") {
      //             localStorage.setItem("tokenData", JSON.stringify(velidateData))
      //             let userAccData = await apiUserService.getDashboard(velidateData.sub);
      //             localStorage.setItem("userAccData", JSON.stringify(userAccData))
      //             if (userAccData) {
      //                let isOfficeChannel = !!userAccData ? userAccData.username === 'office' || (!!userAccData.parents && userAccData.parents.includes('office')) : false;
      //                this.props.setIsOfficeChannel(isOfficeChannel);
      //             }
      //             // setTimeout(() => {
      //             this.setState({ opLoader: false },
      //                () => {
      //                   // this.props.history.push("/clients");
      //                   window.location.href = "/clients"
      //                }
      //             )
      //             // }, 10000);


      //          } else if (!!velidateData.role && velidateData.role === "Client") {
      //             this.props.notify("Client user is not allow to access this portal.", "error")
      //          } else {
      //             this.props.notify(velidateData.exception.message, "error")
      //          }
      //       } else {
      //          this.props.notify(result.exception.message, "error")
      //       }
      //    })
      // } else {
      //    localStorage.clear();
      //    this.props.setIsOfficeChannel(false);
      // }
   }

   getCurrencyLst() {
      currencyService.getCurrencyList().then((res) => {
         if (!!res) {
            if (!!res.isSuccess) {
               this.setState({ currenyList: res.data[0].currencyCode });
            } else {
               this.props.notify(res?.exception?.message, "error")
            }
         }
      });
   }

   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   handleKey(e) {
      if (e.keyCode === 13) {
         this.signIn();
      }
   }
   signIn() {
      if (this.state.uid === "") {
         this.props.notify("Please Insert Username!", "error")
         return false
      }
      if (this.state.passcode === "") {
         this.props.notify("Please Insert Password!", "error")
         return false
      }
      let body = {
         "username": this.state.uid.toLowerCase().trim(),
         "password": this.state.passcode
      }

      if (!(!!this.state.captchaSolution)) {
         this.props.notify("Solve Captcha to move ahead", "error");
         return false;
      }

      body['requestId'] = this.state.requestId;
      body['captchaAnswer'] = this.state.captchaSolution;
      authServices.signin(body).then(async (result) => {
         if (result.token) {
            let data = {
               token: result.token
            }
            localStorage.setItem("userAuthDetail", JSON.stringify(data))
            let velidateData = await authServices.velidateToken()
            if (!!velidateData) {
               localStorage.setItem("tokenData", JSON.stringify(velidateData))
               if (velidateData.pwdch) {
                  this.props.history.push("/setpassword");
               } else {
                  // debugger
                  // let userAccData = await apiUserService.getDashboard(velidateData.sub);
                  // if (userAccData) {
                  //    let isOfficeChannel = !!userAccData ? userAccData.username === 'office' || (!!userAccData.parents && userAccData.parents.includes('office')) : false;
                  //    this.props.setIsOfficeChannel(isOfficeChannel);
                  // }
                  this.props.history.push("/dashboard");
                  // window.location.href= "/dashboard"
               }
            } else {
               this.props.notify(!!velidateData && !!velidateData.exception ? velidateData.exception.message : "", "error")
               document.getElementById('iCaptchaRefresh').click()
            }
         } else {
            this.props.notify(!!result && !!result.exception ? result.exception.message : "", "error")
            document.getElementById('iCaptchaRefresh').click()
         }
      })
   }

   onPasswodVisible(passid, name, value) {
      if (!!value) {
         document.getElementById(passid).type = "password"
      } else {
         document.getElementById(passid).type = "text"
      }
      this.setState({ [name]: !value })
   }

   toggleLogin(val) {
      if (val === 0) {
         this.setState({
            uid: "",
            passcode: "",
            toastMsg: "",
            toastType: "",
            passVisible: false,
            forgPassvisible: false,
            confPassvisible: false,
            signUpPassword: false,
            signUpConfPass: false,
            opLoader: false,
            isMaintenance: false,
            inMaitanenceMessage: '',
            loginForm: 0,
            signUpStep: 0,
            personName: "",
            usernamesignup: "",
            usernamealreadyexist: false,
            passwordsignup: "",
            passwordsignup_confirm: "",
            mobileNumber: "",
            mobilealreadyexist: false,
            mobilealreadyexistchecked: false,
            mobileNumberCountryCode: "",
            mobileNumberisValid: false,
            emailsignup: "",
            confirmPassVisible: false,
            signUpReferenceCode: '',
            currency: '',
            referrer: '',
            website: ''
         })
      } else {
         this.setState({ loginForm: val, signUpStep: 0 });
      }
   }

   signUpStepBtnClick(num = 0) {
      this.setState({ signUpStep: num });
   }

   checkPhoneNumberValidity(countryCode, value) {
      const phonesregex = {
         'AM': /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
         'AE': /^((\+?971)|0)?5[024568]\d{7}$/,
         'BH': /^(\+?973)?(3|6)\d{7}$/,
         'DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
         'EG': /^((\+?20)|0)?1[0125]\d{8}$/,
         'IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
         'JO': /^(\+?962|0)?7[789]\d{7}$/,
         'KW': /^(\+?965)[569]\d{7}$/,
         'SA': /^(!?(\+?966)|0)?5\d{8}$/,
         'SY': /^(!?(\+?963)|0)?9\d{8}$/,
         'TN': /^(\+?216)?[2459]\d{7}$/,
         'BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
         'BG': /^(\+?359|0)?8[789]\d{7}$/,
         'BD': /^(\+?880|0)1[13456789][0-9]{8}$/,
         'CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
         'DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
         'DE': /^(\+49)?0?1(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7}$/,
         'AT': /^(\+43|0)\d{1,4}\d{3,12}$/,
         'GR': /^(\+?30|0)?(69\d{8})$/,
         'AU': /^(\+?61|0)4\d{8}$/,
         'GB': /^(\+?44|0)7\d{9}$/,
         'GG': /^(\+?44|0)1481\d{6}$/,
         'GH': /^(\+?233|0)(20|50|24|54|55|59|25|27|57|26|56|23|28)\d{7}$/,
         'HK': /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
         'MO': /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
         'IE': /^(\+?353|0)8[356789]\d{7}$/,
         'IN': /^(\+?91|0)?[6789]\d{9}$/,
         'KE': /^(\+?254|0)(7|1)\d{8}$/,
         'MT': /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
         'MU': /^(\+?230|0)?\d{8}$/,
         'NG': /^(\+?234|0)?[789]\d{9}$/,
         'NZ': /^(\+?64|0)[28]\d{7,9}$/,
         'PK': /^((\+?92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
         'RW': /^(\+?250|0)?[7]\d{8}$/,
         'SG': /^(\+65)?[89]\d{7}$/,
         'SL': /^(?:0|94|\+94)?(7(0|1|2|5|6|7|8)( |-)?\d)\d{6}$/,
         'TZ': /^(\+?255|0)?[67]\d{8}$/,
         'UG': /^(\+?256|0)?[7]\d{8}$/,
         'US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
         'ZA': /^(\+?27|0)\d{9}$/,
         'ZM': /^(\+?26)?09[567]\d{7}$/,
         'CL': /^(\+?56|0)[2-9]\d{1}\d{7}$/,
         'EC': /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
         'ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
         'MX': /^(\+?52)?(1|01)?\d{10,11}$/,
         'PA': /^(\+?507)\d{7,8}$/,
         'PY': /^(\+?595|0)9[9876]\d{7}$/,
         'UY': /^(\+598|0)9[1-9][\d]{6}$/,
         'EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
         'IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
         'FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
         'FJ': /^(\+?679)?\s?\d{3}\s?\d{4}$/,
         'FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
         'FR': /^(\+?33|0)[67]\d{8}$/,
         'GF': /^(\+?594|0|00594)[67]\d{8}$/,
         'GP': /^(\+?590|0|00590)[67]\d{8}$/,
         'MQ': /^(\+?596|0|00596)[67]\d{8}$/,
         'RE': /^(\+?262|0|00262)[67]\d{8}$/,
         'IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
         'HU': /^(\+?36)(20|30|70)\d{7}$/,
         'ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
         'IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
         'JP': /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
         'KZ': /^(\+?7|8)?7\d{9}$/,
         'GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
         'KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
         'LT': /^(\+370|8)\d{8}$/,
         'MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
         'NO': /^(\+?47)?[49]\d{7}$/,
         'NP': /^(\+?977)?9[78]\d{8}$/,
         'BE': /^(\+?32|0)4?\d{8}$/,
         'NL': /^(\+?31|0)6?\d{8}$/,
         'PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
         'BR': /(?=^(\+?5{2}\-?|0)[1-9]{2}\-?\d{4}\-?\d{4}$)(^(\+?5{2}\-?|0)[1-9]{2}\-?[6-9]{1}\d{3}\-?\d{4}$)|(^(\+?5{2}\-?|0)[1-9]{2}\-?9[6-9]{1}\d{3}\-?\d{4}$)/,
         'PT': /^(\+?351)?9[1236]\d{7}$/,
         'RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
         'RU': /^(\+?7|8)?9\d{9}$/,
         'SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
         'SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
         'RS': /^(\+3816|06)[- \d]{5,9}$/,
         'SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
         'TH': /^(\+66|66|0)\d{9}$/,
         'TR': /^(\+?90|0)?5\d{9}$/,
         'UA': /^(\+?38|8)?0\d{9}$/,
         'VN': /^(\+?84|0)((3([2-9]))|(5([2689]))|(7([0|6-9]))|(8([1-6|89]))|(9([0-9])))([0-9]{7})$/,
         'CN': /^((\+|00)86)?1([358][0-9]|4[579]|6[67]|7[01235678]|9[189])[0-9]{8}$/,
         'TW': /^(\+?886\-?|0)?9\d{8}$/,
         'GE': /^(\+?995\-?|0)?[3457]\d{8}$|[3457]\d{9}$/,
         'LK': /^(?:7|0|(?:94))[0-9]{9,10}$/
      };
      let valid = false;

      const countryRegex = phonesregex[countryCode];
      if (!!countryRegex) {
         valid = countryRegex.test(value);
      }

      return valid;
   }

   onPhoneNumberChange(inputNumber, country, name) {
      // mobilealreadyexistchecked
      this.setState({ [name]: inputNumber, [`${name}CountryCode`]: country.countryCode.toUpperCase(), [`${name}isValid`]: this.checkPhoneNumberValidity(country.countryCode.toUpperCase(), inputNumber) }, () => {
         if (name === "mobileNumber" && this.state.otpSent > 0 && this.state.mobileNumber !== this.state.otpSentTo) {
            clearInterval(sendotpinterval);
            this.setState({ otpSent: 0, otpSentTo: "", resendOtp: 0, otpsignup: "" });
         }
      });
   }



   checkIfUserExists() {
      const self = this;
      if (this.state.usernamesignup !== '' && this.state.usernamesignup.length > 5) {
         let param = {
            "UserName": this.state.usernamesignup
         }
         authServices.checkIfUserExists(this.state.usernamesignup).then(async (result) => {
            if (!!result) {
               self.setState({ usernamealreadyexist: result.isSuccess ? false : true });
            }
         })
      }
   }

   checkIfMobileExists() {
      const self = this;
      if (this.state.mobileNumber !== '' && this.state.mobileNumberisValid) {
         let param = {
            "Mobile": this.state.mobileNumber
         }
         authServices.checkIfMobileExists(this.state.mobileNumber).then(async (result) => {
            if (!!result) {
               self.setState({ mobilealreadyexist: result.isSuccess ? false : true, mobilealreadyexistchecked: true });
            }
            // self.setState({mobilealreadyexist : result ? false : true, mobilealreadyexistchecked: true})
         })
      }
   }

   validateForSubmit(onlyForMobile = false) {
      if (onlyForMobile) {
         return this.state.mobileNumber === "" || !this.state.mobileNumberisValid
      } else {
         return this.state.usernamesignup === "" || this.state.usernamesignup.length < 6 || (this.state.otpsignup === "" || this.state.otpsignup.length !== 6) || this.state.personName === "" || (this.state.passwordsignup === "" || this.state.passwordsignup_confirm === "" || !(this.state.passwordsignup.match(/[0-9]/g)) || !(this.state.passwordsignup.match(/[a-zA-Z]/g)) || this.state.passwordsignup.length < 8 || this.state.passwordsignup.toLowerCase().indexOf(this.state.usernamesignup.toLowerCase()) > -1 || this.state.passwordsignup !== this.state.passwordsignup_confirm) || this.state.mobileNumber === "" || !this.state.mobileNumberisValid || this.state.usernamealreadyexist || this.state.emailsignup === "" || !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailsignup.trim())) || this.state.currency === ""
      }
      //return false;
   }

   signUp() {
      const self = this;
      // if (this.state.uid === "") {
      //    this.props.notify("Please Insert Username!", "error")
      //    return false
      // }
      // if (this.state.passcode === "") {
      //    this.props.notify("Please Insert Password!", "error")
      //    return false
      // }
      let body = {
         "username": this.state.usernamesignup.toLowerCase().trim(),
         "name": this.state.personName,
         "email": this.state.emailsignup,
         "mobile": this.state.mobileNumber,
         "parentId": this.state.referrer.trim().toUpperCase(),
         "password": this.state.passwordsignup,
         "website": this.state.website,
         "currencyCode": this.state.currency,
         "otp": this.state.otpsignup
      }
      // "dateOfBirth": this.state.dateOfBirth,
      // "otherDropDown": this.state.otherDrop,
      // "otherText": this.state.otherTxt,
      authServices.signUpAffiliate(body).then(async (result) => {
         if (result.isSuccess) {
            self.props.notify("Registered successfully!", "success");
            self.setState({
               uid: "",
               passcode: "",
               toastMsg: "",
               toastType: "",
               passVisible: false,
               forgPassvisible: false,
               confPassvisible: false,
               signUpPassword: false,
               signUpConfPass: false,
               opLoader: false,
               isMaintenance: false,
               inMaitanenceMessage: '',
               loginForm: 0,
               signUpStep: 0,
               personName: "",
               usernamesignup: "",
               usernamealreadyexist: false,
               passwordsignup: "",
               passwordsignup_confirm: "",
               mobileNumber: "",
               mobilealreadyexist: false,
               mobilealreadyexistchecked: false,
               mobileNumberCountryCode: "",
               mobileNumberisValid: false,
               emailsignup: "",
               confirmPassVisible: false,
               signUpReferenceCode: '',
               currency: '',
               referrer: '',
               website: ''
            })
         } else {
            self.props.notify(result.exception.message, "error")
         }
      })
   }


   forgotPasswordSubmit() {
      const self = this;
      let body = {
         "username": this.state.uid.toLowerCase().trim(),
      }
      authServices.forgotPasswordApi(body).then(async (result) => {
         if (result.isSuccess) {
            self.props.notify("OTP sent to registered mobile number!", "success");
            self.setState({
               loginForm: -2
            })
         } else {
            self.props.notify(result.exception.message, "error")
         }
      })

   }

   validateResetPassword() {
      return (this.state.otp === "" || this.state.otp.length < 6) || (this.state.passwordsignup === "" || this.state.passwordsignup_confirm === "" || !(this.state.passwordsignup.match(/[0-9]/g)) || !(this.state.passwordsignup.match(/[a-zA-Z]/g)) || this.state.passwordsignup.length < 8 || this.state.passwordsignup.toLowerCase().indexOf(this.state.uid.toLowerCase()) > -1 || this.state.passwordsignup !== this.state.passwordsignup_confirm)
   }

   resetPasswordSubmit() {
      const self = this;
      let body = {
         "otp": this.state.otp,
         "password": this.state.passwordsignup,
         "userName": this.state.uid.toLowerCase().trim()
      }
      authServices.forgotResetPasswordApi(body).then(async (result) => {
         if (result.isSuccess) {
            self.props.notify("Password set successfully!", "success");
            self.setState({
               uid: "",
               passcode: "",
               toastMsg: "",
               toastType: "",
               passVisible: false,
               forgPassvisible: false,
               confPassvisible: false,
               signUpPassword: false,
               signUpConfPass: false,
               opLoader: false,
               isMaintenance: false,
               inMaitanenceMessage: '',
               loginForm: 0,
               signUpStep: 0,
               personName: "",
               usernamesignup: "",
               usernamealreadyexist: false,
               passwordsignup: "",
               passwordsignup_confirm: "",
               mobileNumber: "",
               mobilealreadyexist: false,
               mobilealreadyexistchecked: false,
               mobileNumberCountryCode: "",
               mobileNumberisValid: false,
               emailsignup: "",
               confirmPassVisible: false,
               signUpReferenceCode: '',
               currency: '',
               referrer: '',
               website: '',
               otp: ''
            })
         } else {
            self.props.notify(result.exception.message, "error")
         }
      })
   }

   sendOTP(resend = false) {
      const self = this;
      if (!this.validateForSubmit(true)) {
         const body = {
            'mobile': this.state.mobileNumber,
            'isResend': resend
         }
         authServices.sendOTP(body).then(async (result) => {
            if (!!result && !!result.isSuccess && result.isSuccess) {
               const otpSent = self.state.otpSent + 1;
               self.setState({ otpSent: otpSent, otpSentTo: self.state.mobileNumber, resendOtp: 60 }, () => {
                  self.sendOtpIntervalStart();
               });
            } else {
               self.props.notify(result.exception.message, 'error');
            }
         })
      }
   }

   sendOtpIntervalStart() {
      const self = this;
      sendotpinterval = setInterval(async function sendotpintervalagain() {
         clearInterval(sendotpinterval)
         if (self.state.resendOtp > 0) {
            // debugger
            const resendOtp = self.state.resendOtp - 1;
            self.setState({ resendOtp: resendOtp }, () => {
               sendotpinterval = setInterval(sendotpintervalagain, 1000)
               return false
            });
         }
      }, 1000)
   }



   updateCaptchaData(requestId, solution, expiryCaptcha) {
      this.setState({
         requestId: requestId,
         captchaSolution: solution,
         expiryCaptcha: expiryCaptcha
      });
   }

   render() {
      return (
         <>
            {!this.state.isMaintenance ?
               <body className="bethubs">
                  {/* <div className="devheader">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12">dev </div>
                          </div>
                        </div>
                      </div> */}
                  <div className="loginbg">
                     {/* <span className="tag-live" style={{ left: "0px", top: "0px", width: "100%", zIndex: "1", position: "fixed" }}>DEV</span> */}


                     {/*----- forgot password MODAL-POPUP START -----*/}
                     {
                        this.state.loginForm === -2 &&
                        <>
                           <div className="login">
                              <div><h3 className="text-center"><img alt="" src={`${BASE_IMAGE_PATH}/aimg/${BRANDLOGOFILENAME}`} /></h3></div>
                              <div>
                                 <div className="form-group">
                                    <label htmlFor="otp">OTP <span className='required'>*</span></label>
                                    <input type="number" tabIndex={1} autoCapitalize="off" autoCorrect="off" spellCheck="false" className="form-control" placeholder="Enter OTP" name="otp" value={this.state.otp} onChange={(e) => { this.onChange(e) }} />
                                 </div>
                                 <div className="form-group">
                                    <label htmlFor="pwd">Password <span className='required'>*</span></label>
                                    <input tabIndex={2} type="password" className="form-control" placeholder="6-20 characters or numbers" name="passwordsignup" id="passwordsignup" value={this.state.passwordsignup} onKeyUp={(e) => { this.handleKey(e) }} onChange={(e) => { this.onChange(e) }} />
                                    <span onClick={() => { this.onPasswodVisible("passwordsignup", "forgPassvisible", this.state.forgPassvisible) }} className="Passcode-visible">{!!this.state.forgPassvisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                    {!!this.state.passwordsignup &&
                                       <>
                                          <ul className='d-flex change-password-valid'>
                                             <li id="digit" className={this.state.passwordsignup.match(/[0-9]/g) ? "signup-validation-text success-text mr-1" : "signup-validation-text mr-1"}><i className="fa fa-check"></i> At least 1 digit</li>
                                             <li id="scharacter" className={this.state.passwordsignup.match(/[a-zA-Z]/g) ? "signup-validation-text success-text mr-1" : "signup-validation-text mr-1"}><i className="fa fa-check"></i> At least 1 character</li>
                                             <li id="minlength" className={this.state.passwordsignup.length >= 8 ? "signup-validation-text success-text" : "signup-validation-text"}><i className="fa fa-check"></i> Minimum 8 characters</li>
                                          </ul>
                                          <ul className='change-password-valid'>
                                             <li id="notuser" className={this.state.passwordsignup.toLowerCase().indexOf((this.state.loginForm === -2 ? this.state.uid.toLowerCase() : this.state.usernamesignup.toLowerCase())) > -1 ? "signup-validation-text error-text" : "d-none"}><i className="fa fa-close"></i> Password can't contain Username</li>
                                          </ul>
                                       </>
                                    }
                                 </div>
                                 <div className="form-group">
                                    <label htmlFor="pwd">Confirm Password <span className='required'>*</span></label>
                                    <input tabIndex={3} type="password" className="form-control" placeholder="" name="passwordsignup_confirm" id="passwordsignup_confirm" value={this.state.passwordsignup_confirm} onKeyUp={(e) => { this.handleKey(e) }} onChange={(e) => { this.onChange(e) }} />
                                    <span onClick={() => { this.onPasswodVisible("passwordsignup_confirm", "confPassvisible", this.state.confPassvisible) }} className="Passcode-visible">{!!this.state.confPassvisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                    {this.state.passwordsignup !== "" && this.state.passwordsignup !== this.state.passwordsignup_confirm ? <span className='error' style={{ color: "red" }}>This field should be same as password.</span> : null}
                                 </div>
                                 <div><button tabIndex={3} type="button" className="text-center login-bt" disabled={this.validateResetPassword()} onClick={() => { this.resetPasswordSubmit() }}>Submit</button></div>
                                 <div><button tabIndex={3} type="button" className="text-center reg-bt" onClick={() => { this.toggleLogin(0) }}>Cancel</button></div>
                              </div>
                           </div>

                        </>
                     }
                     {
                        this.state.loginForm === -1 &&
                        <>
                           <div className="login">
                              <div><h3 className="text-center"><img alt="" src={`${BASE_IMAGE_PATH}/aimg/${BRANDLOGOFILENAME}`} /></h3></div>
                              <div>
                                 <div className="form-group">
                                    <label htmlFor="email">User Name <span className='required'>*</span></label>
                                    <input type="text" tabIndex={1} autoFocus autoCapitalize="off" autoCorrect="off" spellCheck="false" className="form-control" placeholder="Enter User Name" name="uid" value={this.state.uid} onChange={(e) => { this.onChange(e) }} />
                                    <span className="error d-none">Error</span>
                                 </div>
                                 <div><button tabIndex={3} type="button" className="text-center login-bt" disabled={this.state.uid === "" || this.state.uid.length < 6} onClick={() => { this.forgotPasswordSubmit() }}>Submit</button></div>
                                 <div><button tabIndex={3} type="button" className="text-center reg-bt" onClick={() => { this.toggleLogin(0) }}>Cancel</button></div>
                              </div>
                           </div>

                        </>
                     }
                     {/*----- forgot password MODAL-POPUP END -----*/}

                     {/*----- LOGIN MODAL-POPUP START -----*/}
                     {
                        this.state.loginForm === 0 &&
                        <>
                           <div className="login">
                              <div><h3 className="text-center"><img alt="" src={`${BASE_IMAGE_PATH}/aimg/${BRANDLOGOFILENAME}`} /></h3></div>
                              <div>
                                 <div className="form-group">
                                    <label htmlFor="email">User Name <span className='required'>*</span></label>
                                    <input type="text" tabIndex={1} autoFocus autoCapitalize="off" autoCorrect="off" spellCheck="false" className="form-control" placeholder="Enter User Name" name="uid" value={this.state.uid} onChange={(e) => { this.onChange(e) }} />
                                    <span className="error d-none">Error</span>
                                 </div>
                                 <div className="form-group">
                                    <label htmlFor="pwd">Password <span className='required'>*</span></label>
                                    <input tabIndex={2} type="password" className="form-control" placeholder="Enter password" name="passcode" id="passcode" value={this.state.passcode} onKeyUp={(e) => { this.handleKey(e) }} onChange={(e) => { this.onChange(e) }} />
                                    <span onClick={() => { this.onPasswodVisible("passcode", "passVisible", this.state.passVisible) }} className="Passcode-visible">{!!this.state.passVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                    <div className='forgot-password-div'>
                                       <span className='forgot-password-link for_mar_right' onClick={() => this.toggleLogin(-1)}>forgot password</span>
                                    </div>
                                 </div>
                                 <div className="form-group">
                                    <CaptchaComp updateCaptchaData={(requestId, solution, expiryCaptcha) => this.updateCaptchaData(requestId, solution, expiryCaptcha)} />
                                 </div>
                                 <div><button tabIndex={3} type="button" className="text-center login-bt" onClick={() => { this.signIn() }}>LOGIN</button></div>
                                 <div><button tabIndex={3} type="button" className="text-center reg-bt" onClick={() => { this.toggleLogin(1) }}>SIGN UP</button></div>
                              </div>
                           </div>

                        </>
                     }
                     {/*----- LOGIN MODAL-POPUP END -----*/}



                     {/*----- SIGN UP MODAL-POPUP START -----*/}
                     {this.state.loginForm === 1 &&
                        <>
                           <div className="sign-up">
                              <div><h3 className="text-center"><img alt="" src={`${BASE_IMAGE_PATH}/aimg/${BRANDLOGOFILENAME}`} /></h3></div>

                              {/* step 1 start */}
                              {this.state.signUpStep === 0 &&
                                 <div className=''>
                                    <div className="form-group">
                                       <label htmlFor="usernamesignup">User Name <span className='required'>*</span></label>
                                       <input type="text" tabIndex={1} autoFocus autoCapitalize="off" autoCorrect="off" spellCheck="false" className="form-control" placeholder="6-18 characters or numbers" name="usernamesignup" value={this.state.usernamesignup} onChange={(e) => { this.onChange(e) }} onBlur={() => { this.checkIfUserExists() }} />
                                       {/* <span className="error d-none">Error</span> */}
                                       {this.state.usernamesignup !== "" && this.state.usernamesignup.indexOf(' ') > -1 ? <span id='usernospacelbl' className="error">This field cannot have space.</span> : null}
                                       {this.state.usernamesignup !== "" && this.state.usernamesignup.length < 6 ? <span id='userminlengthlbl' className="error">Minimum 6 characters</span> : null}
                                       {this.state.usernamesignup !== "" && this.state.usernamealreadyexist ? <span id='useralreadyexistlbl' className="error">This Username already exist.</span> : null}
                                    </div>
                                    <div className="form-group">
                                       <label htmlFor="pwd">Password <span className='required'>*</span></label>
                                       <input tabIndex={2} type="password" className="form-control" placeholder="6-20 characters or numbers" name="passwordsignup" id="passwordsignup" value={this.state.passwordsignup} onKeyUp={(e) => { this.handleKey(e) }} onChange={(e) => { this.onChange(e) }} />
                                       <span onClick={() => { this.onPasswodVisible("passwordsignup", "signUpPassword", this.state.signUpPassword) }} className="Passcode-visible">{!!this.state.signUpPassword ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                       {!!this.state.passwordsignup &&
                                          <>
                                             <ul className='d-flex change-password-valid'>
                                                <li id="digit" className={this.state.passwordsignup.match(/[0-9]/g) ? "signup-validation-text success-text mr-1" : "signup-validation-text mr-1"}><i className="fa fa-check"></i> At least 1 digit</li>
                                                <li id="scharacter" className={this.state.passwordsignup.match(/[a-zA-Z]/g) ? "signup-validation-text success-text mr-1" : "signup-validation-text mr-1"}><i className="fa fa-check"></i> At least 1 character</li>
                                                <li id="minlength" className={this.state.passwordsignup.length >= 8 ? "signup-validation-text success-text" : "signup-validation-text"}><i className="fa fa-check"></i> Minimum 8 characters</li>
                                             </ul>
                                             <ul className='change-password-valid'>
                                                <li id="notuser" className={this.state.passwordsignup.toLowerCase().indexOf(this.state.usernamesignup.toLowerCase()) > -1 ? "signup-validation-text error-text" : "d-none"}><i className="fa fa-close"></i> Password can't contain Username</li>
                                             </ul>
                                          </>
                                       }
                                    </div>
                                    <div className="form-group">
                                       <label htmlFor="pwd">Confirm Password <span className='required'>*</span></label>
                                       <input tabIndex={3} type="password" className="form-control" placeholder="" name="passwordsignup_confirm" id="passwordsignup_confirm" value={this.state.passwordsignup_confirm} onKeyUp={(e) => { this.handleKey(e) }} onChange={(e) => { this.onChange(e) }} />
                                       <span onClick={() => { this.onPasswodVisible("passwordsignup_confirm", "signUpConfPass", this.state.signUpConfPass) }} className="Passcode-visible">{!!this.state.signUpConfPass ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                       {this.state.passwordsignup !== "" && this.state.passwordsignup !== this.state.passwordsignup_confirm ? <span className='error' style={{ color: "red" }}>This field should be same as password.</span> : null}
                                    </div>
                                    <div className="form-group">
                                       <label htmlFor="currency">Currency <span className='required'>*</span></label>
                                       <select className="form-control" tabIndex={4} id="currency" name="currency" value={this.state.currency} onChange={(e) => { this.onChange(e) }}>
                                          <option value=""></option>
                                          {!!this.state.currenyList && this.state.currenyList.length > 0 && this.state.currenyList.map((itm, ind) => <option value={itm}>{itm}</option>)}
                                       </select>
                                       {this.state.passwordsignup !== "" && this.state.passwordsignup !== this.state.passwordsignup_confirm ? <label className='signup-validation-text' style={{ color: "red" }}>This field should be same as password.</label> : null}
                                    </div>

                                    <div className="form-group">
                                       <label htmlFor="email">Name <span className='required'>*</span></label>
                                       <input type="text" tabIndex={5} autoFocus autoCapitalize="off" autoCorrect="off" spellCheck="false" className="form-control" placeholder="" name="personName" value={this.state.personName} onChange={(e) => { this.onChange(e) }} />
                                       <span className="error d-none">Error</span>
                                    </div>
                                    <div>
                                       <div className='d-inline-block w-50'>
                                          <button tabIndex={6} type="button" className="text-center login-bt" onClick={() => { this.signUpStepBtnClick(1) }}>Next</button>
                                       </div>
                                       <div className='d-inline-block w-50'>
                                          <button tabIndex={7} type="button" className="text-center reg-bt ml-1" onClick={() => { this.toggleLogin(0) }}>Cancel</button>
                                       </div>

                                    </div>
                                 </div>
                              }
                              {/* STep 1 END */}

                              {/* step 2 start */}
                              {this.state.signUpStep === 1 &&
                                 <div className=''>

                                    {/* <div className="form-group">
                                       <label className="label bold">Date of Birth <span className='required'>*</span></label>
                                       <input className="form-control" name="signUpDOB" type="date" max={this.state.signUpMaxDate} min={this.state.signUpMinDate} aria-required="true" value={this.state.signUpDOB} onChange={(e) => { this.onChange(e) }}/> onBlur={this.checkIfMobileExists()}
                                    </div> */}
                                    <div className="form-group p-relative">
                                       <label htmlFor="inputPassword" className="d-block">Phone <span className='required'>*</span></label>
                                       <PhoneInput className="w-100" specialLabel="" tabIndex={8} country={'in'} value={this.state.mobileNumber} name="mobileNumber" onChange={(inputNumber, country) => { this.onPhoneNumberChange(inputNumber, country, 'mobileNumber') }} placeholder="Enter Mobile Number" />
                                       {this.state.mobileNumber !== "" && this.state.mobilealreadyexist ? <label id='mobilealreadyexistlbl' className="signup-validation-text error-text" style={{ color: "red" }}>This mobile number already exists.</label> : null}

                                       <button className='btn-type-submit otpbtnnew' disabled={this.validateForSubmit(true)} onClick={() => { this.sendOTP() }}>
                                          {this.state.buttonLoader &&
                                             <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                                             </svg>}
                                          Get Code
                                       </button>
                                       {/* <div>
                                          <div className='d-inline-block w-25'>
                                             <select className="form-control" id="exampleFormControlSelect1">
                                                <option>+91</option>
                                                <option>+91</option>
                                                <option>+92</option>
                                                <option>+64</option>
                                             </select>
                                          </div>
                                          <div className='d-inline-block w-75 '>
                                             <input type="text" className="form-control w-98-signup ml-1" id="inputPassword" placeholder="number" />
                                          </div>
                                       </div> */}
                                    </div>
                                    <div className="form-group">
                                       <label htmlFor="exampleFormControlInput1">Enter Code <span className='required'>*</span></label>
                                       <input type="email" tabIndex={9} value={this.state.otpsignup} name="otpsignup" maxLength="6" class="form-control" onChange={(e) => this.onChange(e)} disabled={this.state.otpSent === 0} placeholder="Enter OTP" />

                                       {this.state.otpSent !== 0 &&
                                          <>
                                             {this.state.resendOtp > 0 ?
                                                <div className='resend-otp' style={{ textDecoration: 'none' }}><a href="#">Resend OTP in {this.state.resendOtp} secs</a></div>
                                                :
                                                <div className='resend-otp'><a href="#" className='f-color-white' onClick={() => { this.sendOTP() }}>Resend OTP</a></div>
                                             }
                                          </>
                                       }
                                    </div>
                                    <div className="form-group">
                                       <label htmlFor="exampleFormControlInput1">Email <span className='required'>*</span></label>
                                       <input type="email" tabIndex={10} className="form-control" id="exampleFormControlInput1" placeholder="" name="emailsignup" value={this.state.emailsignup} onChange={(e) => { this.onChange(e) }} />
                                    </div>
                                    {/* <div className="form-group ">
                                       <label htmlFor="inputPassword" className="d-block">Other</label>
                                       <div>
                                          <div className='d-inline-block w-25'>
                                             <select className="form-control" id="otherDrop" name="otherDrop" value={this.state.otherDrop} onChange={(e) => { this.onChange(e) }}>
                                                <option value=''></option>
                                                <option value={'QQ'}>QQ</option>
                                                <option value={'Wechat'}>Wechat</option>
                                                <option value={'Skype'}>Skype</option>
                                                <option value={'Zalo'}>Zalo</option>
                                                <option value={'Telegram'}>Telegram</option>
                                                <option value={'WhatsApp'}>WhatsApp</option>
                                                <option value={'KakaoTalk'}>KakaoTalk</option>
                                                <option value={'Line'}>Line</option>
                                                <option value={'IMO'}>IMO</option>
                                                <option value={'Viber'}>Viber</option>
                                                <option value={'FBMessenger'}>FBMessenger</option>
                                                <option value={'FACEBOOK'}>FACEBOOK</option>
                                                <option value={'GOOGLE'}>GOOGLE</option>
                                             </select>
                                          </div>
                                          <div className='d-inline-block w-75 '>
                                             <input type="text" className="form-control w-98-signup ml-1" id="otherTxt" name="otherTxt" value={this.state.otherTxt} onChange={(e) => { this.onChange(e) }} />
                                          </div>
                                          <div className="form-group">
                                             <label htmlFor="referrer">Referrer</label>
                                             <input type="email" className="form-control" id="referrer" value={this.state.referrer} onChange={(e) => { this.onChange(e) }}/>
                                          </div>
                                       </div>
                                    </div> */}
                                    <div className="form-group">
                                       <label htmlFor="referrer">Referrer</label>
                                       <input type="text" tabIndex={11} className="form-control text-transform-uppercase" id="referrer" name="referrer" value={this.state.referrer} onChange={(e) => { this.onChange(e) }} />
                                    </div>
                                    <div className="form-group">
                                       <label htmlFor="exampleFormControlInput1">Website</label>
                                       <input type="url" tabIndex={12} className="form-control" id="website" name="website" value={this.state.website} onChange={(e) => { this.onChange(e) }} />
                                    </div>
                                    <div className='d-inline-block w-33'>
                                       <button tabIndex={13} type="button" className="text-center login-bt" onClick={() => { this.signUpStepBtnClick(0) }}>Previous</button>
                                    </div>
                                    <div className='d-inline-block w-33'>
                                       <button tabIndex={14} type="button" className="text-center login-bt" disabled={this.validateForSubmit()} onClick={() => { this.signUp() }}>Sign Up</button>
                                    </div>
                                    <div className='d-inline-block w-33'>
                                       <button tabIndex={15} type="button" className="text-center reg-bt" onClick={() => { this.toggleLogin() }}>Cancel</button>
                                    </div>
                                 </div>
                              }
                              {/* STep 2 END */}
                           </div>
                        </>

                     }
                     {/*----- SIGN UP MODAL-POPUP START -----*/}
                  </div>
                  {this.state.opLoader &&
                     <div className="pleasewaitloader">
                        <div className="pleasetext">
                           Please Wait ...
                        </div>
                     </div>
                  }
                  {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
               </body>
               :
               <UnderMaintenance inMaitanenceMessage={this.state.inMaitanenceMessage} />
            }
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(Auth);